/**
 * SELU 06B-R6 – Produktseiten-eigenes, eng begrenztes JS.
 *
 * Diese Datei wird ausschliesslich von sections/product-information.liquid
 * eingebunden (kein Eintrag in layout/theme.liquid) - sie laedt also
 * NIE auf anderen Seiten (Header, Homepage, Collections, Cart, Checkout).
 * Sie definiert keine globalen Funktionen/Variablen ausserhalb dieses
 * Moduls, registriert keine Listener auf "document"/"window" mit
 * seitenweiter Wirkung (nur scroll-bezogene IntersectionObserver,
 * siehe Abschnitt 3) und fasst KEINE Quickbuy-/Cart-/Checkout-Dateien
 * an. Alle drei Funktionsbloecke unten suchen ihre Elemente
 * ausschliesslich innerhalb von [data-template="product"] und brechen
 * sauber ab (kein Fehler), falls die jeweiligen Elemente fehlen (z. B.
 * weil ein Produkt keine Detail-Metafelder hat).
 */

(function () {
  'use strict';

  var root = document.querySelector('[data-template="product"]');
  if (!root) return;

  /* ----------------------------------------------------------------
     0) R9 Desktop sidebar placement
     The desktop feature/trust sidebar is rendered outside the product grid
     so Quickbuy does not receive product-page-only structure changes. On the
     real product page only, move that prepared node into the native product
     details column after the purchase/upsell block. If anything is missing,
     fail silently and leave the source node hidden by CSS.
  ---------------------------------------------------------------- */
  var r9Sidebar = root.querySelector('[data-selu-r9-sidebar-source]');
  var r9DetailsContent = root.querySelector(
    '.product-information [data-product-grid-content] .product-details > .group-block > .group-block-content'
  );

  if (r9Sidebar && r9DetailsContent && !r9DetailsContent.contains(r9Sidebar)) {
    r9DetailsContent.appendChild(r9Sidebar);
  }

  /* ----------------------------------------------------------------
     0b) R11 mobile trust placement
     Mobile no longer depends on the editable/native text_trustbadges block.
     Move the dedicated trust snippet into the product details flow after
     the purchase/upsell group, so it appears below "Dazu passend" and
     before Beschreibung/Details. If anything is missing, fail silently.
  ---------------------------------------------------------------- */
  var mobileTrust = root.querySelector('[data-selu-mobile-trust-source]');

  if (mobileTrust && r9DetailsContent && !r9DetailsContent.contains(mobileTrust)) {
    r9DetailsContent.appendChild(mobileTrust);
  }

  /* ----------------------------------------------------------------
     1) Feature-Icon-Karte: gemeinsames Detail-Panel
     Klick auf eine Kachel mit [data-selu-feature-trigger] befuellt
     UND zeigt das eine, gemeinsame [data-selu-feature-panel] direkt
     unterhalb der gesamten Icon-Reihe. Erneuter Klick auf dieselbe
     Kachel schliesst das Panel wieder. Kacheln ohne Detailtext sind
     einfache <div>s (kein [data-selu-feature-trigger]) und werden
     hier gar nicht erst angefasst.
  ---------------------------------------------------------------- */
  var featureModules = root.querySelectorAll('[data-selu-feature-module]');

  featureModules.forEach(function (module) {
    var featureTriggers = module.querySelectorAll('[data-selu-feature-trigger]');
    var featurePanel = module.querySelector('[data-selu-feature-panel]');

    if (!featureTriggers.length || !featurePanel) return;

    featureTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var isActive = trigger.classList.contains('is-active');

        featureTriggers.forEach(function (otherTrigger) {
          otherTrigger.classList.remove('is-active');
          otherTrigger.setAttribute('aria-expanded', 'false');
        });

        if (isActive) {
          featurePanel.hidden = true;
          featurePanel.textContent = '';
          return;
        }

        trigger.classList.add('is-active');
        trigger.setAttribute('aria-expanded', 'true');
        featurePanel.textContent = trigger.getAttribute('data-detail') || '';
        featurePanel.hidden = false;
      });
    });
  });

  /* ----------------------------------------------------------------
     2) "Beschreibung | Details" Reiter
     Klick auf [data-selu-tab-trigger] zeigt das passende
     [data-selu-tab-panel] und blendet das jeweils andere aus. Erster
     Reiter ("beschreibung") ist im Markup bereits ohne JS sichtbar
     (sauberer Fallback) - hier wird beim Laden nur sichergestellt,
     dass der Zustand konsistent ist, falls ein anderer Reiter aus
     irgendeinem Grund im Markup als aktiv markiert waere.
  ---------------------------------------------------------------- */
  var tabContainers = root.querySelectorAll('[data-selu-info-tabs]');

  tabContainers.forEach(function (container) {
    var tabTriggers = container.querySelectorAll('[data-selu-tab-trigger]');
    var tabPanels = container.querySelectorAll('[data-selu-tab-panel]');

    if (!tabTriggers.length || !tabPanels.length) return;

    tabTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var targetKey = trigger.getAttribute('data-selu-tab-trigger');

        tabTriggers.forEach(function (otherTrigger) {
          var isTarget = otherTrigger === trigger;
          otherTrigger.classList.toggle('is-active', isTarget);
          otherTrigger.setAttribute('aria-selected', isTarget ? 'true' : 'false');
        });

        tabPanels.forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-selu-tab-panel') !== targetKey;
        });
      });
    });
  });

  /* ----------------------------------------------------------------
     3) Mobile Sticky-Buy-Bar: rein visuelles Abdimmen im Info-Bereich
     Das native Theme-Feature "sticky-add-to-cart" (assets/sticky-
     add-to-cart.js, NICHT Teil dieser Datei, NICHT veraendert) blendet
     einen schwebenden Kauf-Button ein, sobald die echten Kaufbuttons
     aus dem Sichtbereich scrollen. Dieser schwebende Button liegt per
     Design IMMER ueber dem Seiteninhalt (position: fixed) - das ist
     normales, seitenweites Verhalten dieses Theme-Features und wird
     hier NICHT veraendert.
     Einzige Ergaenzung hier: Solange der neue "Beschreibung/Details"-
     Bereich im sichtbaren Ausschnitt steht, wird dem <body> die Klasse
     "selu-info-area-in-view" hinzugefuegt; eine rein visuelle CSS-
     Regel (siehe assets/selu-custom.css) reduziert dadurch NUR die
     Deckkraft des bereits gestickten Buttons - der Button bleibt im
     DOM, bleibt klickbar/funktionsfaehig, seine eigene JS-Logik
     (data-stuck-Attribut, IntersectionObserver) wird nicht angefasst.
     Existiert der Info-Tabs-Bereich nicht (z. B. anderes Template),
     bricht dieser Block sauber ab.
  ---------------------------------------------------------------- */
  var infoTabsEls = root.querySelectorAll('[data-selu-info-tabs]');

  if (infoTabsEls.length && 'IntersectionObserver' in window) {
    var visibleInfoAreas = 0;
    var dimObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          visibleInfoAreas += entry.isIntersecting ? 1 : -1;
          if (visibleInfoAreas < 0) visibleInfoAreas = 0;
        });
        document.body.classList.toggle('selu-info-area-in-view', visibleInfoAreas > 0);
      },
      { rootMargin: '-40% 0px -10% 0px' }
    );

    infoTabsEls.forEach(function (infoTabsEl) {
      dimObserver.observe(infoTabsEl);
    });
  }
})();
